import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src927551835/src/src/app/ui/common/side-menu.tsx");
